// tab_nav 菜单按钮列表
const tab_list = [
  {
      value: "1",
      label: 'Base maintenance',
      component_name: 'TabContentOne'
  },
  {
      value: "2",
      label: 'Online maintenance',
      component_name: 'TabContentTwo'
  },
  {
      value: "3",
      label: 'Spare parts supply',
      component_name: 'TabContentThree'
  },
  {
      value: "4",
      label: 'Upgrading and reconstruction',
      component_name: 'TabContentFour'
  },
  {
      value: "5",
      label: 'Diagnostic test',
      component_name: 'TabContentFive'
  },
  {
      value: "6",
      label: 'Technical training',
      component_name: 'TabContentSix'
  }
]


// main content 头部文本
const main_content_text = [
  `Sixty years of deep cultivation in the field of industrial flow control, Wuxi Kelke, with the attitude of "full-brand compatible operation and maintenance experts", has built an agile service network covering the whole country, equipped with an industrial-grade high-precision testing platform and mobile intelligent repair shelter, and provided double-track services of quick on-site repair and deep maintenance.`,
  `From ultra-low temperature cryogenic valve to nuclear main steam control valve, from petroleum refining to clean energy engineering, to break through technical barriers with original factory-level process standards, escort the global top 500 enterprises equipment zero downtime operation. With ingenuity and wisdom, KELK uses the core technology matrix and all-weather response system to enable the industry pulsation to continue.`
]


// main content 列表
const main_content_list = [
  {
      value: 1,
      title: 'Base maintenance',
      content: [
          `KELK offers professional services for all types of valves - regardless of construction type, size or manufacturer. We offer a variety of services related to control valve repair, mainly including:`,
          `Provide users with on-site emergency support services, including emergency fault handling, emergency spare parts and other special services; Provide centralized maintenance services for the user's on-site device parking control valve, including online maintenance and...`
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw01.jpg',
      bg_img_class: 'main-content__list-item__img-bg1'
  },
  {
      value: 2,
      title: 'Online maintenance',
      content: [
          'KELK provides professional valve maintenance services. Prevents failures and ensures reliable operation and high availability of equipment.',
          `All services are tailored to ensure a good start and are also available for other manufacturers' products.`
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw02.jpg',
      bg_img_class: 'main-content__list-item__img-bg2'
  },
  {
      value: 3,
      title: 'Spare parts mapping',
      content: [
          `KELK Service has a wide range of materials in stock to ensure that most parts are available quickly when valves are serviced and overhauled. At the same time, it maintains dynamic data linkage with some valve manufacturers' spare parts library, which can provide users with fast spare parts service.`
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw03.jpg',
      bg_img_class: 'main-content__list-item__img-bg3'
  },
  {
      value: 4,
      title: 'Upgrading and reconstruction',
      content: [
          'In recent years, our upgrade and retrofit services have helped customers around the world to keep their equipment performing well even under harsh operating conditions. Typical projects include upgrading valve internals to avoid sand impurities, replacing them with cemented carbide and LCV valve internals to reduce cavitation effects, and so on.'
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw04.jpg',
      bg_img_class: 'main-content__list-item__img-bg4'
  },
  {
      value: 5,
      title: 'Diagnostic test',
      content: [
          'KELK has its own laboratory, we have experts in field analysis, and we can perform all non-destructive and mechanical tests on materials, mainly including X-ray, ultrasonic and microscopic structure inspection. All inspection results are certified and we are able to carry out complex material, metallurgical and electronic component tests...'
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw05.jpg',
      bg_img_class: 'main-content__list-item__img-bg5'
  },
  {
      value: 6,
      title: 'Technical training',
      content: [
          `Our courses are progressive and we can also work with you to assess your staff's training requirements and recommend appropriate courses to ensure the desired learning results are achieved. We have received very positive training feedback from our customers, and proper training helps customers understand the valve in their scope of work.`
      ],
      button_text: 'MORE',
      images1: '@/assets/images1/customer_service/khfw06.jpg',
      bg_img_class: 'main-content__list-item__img-bg6'
  }
]



// 基地维修
const baseMmaintenance = {
  title: 'Full brand full scene coverage',
  content: `
  Wuxi Kelke provides a full range of valve repair services, compatible with global brands, without fear of structural differences, size restrictions and technological barriers.<br />
  National fluid control laboratory and 3D laser mapping technology, from ultra-low temperature deep-cooling valve to nuclear high pressure control valve, we provide customized disassembly testing, core component repair, intelligent upgrade and transformation one-stop service, strictly follow API/ISO certification standards, so that every valve to restore industrial precision and reliability.
  `,
  group1: {
    title: 'The maintenance services we provide mainly include',
    list: [
      'Provide users with on-site emergency support services, including emergency fault handling, emergency spare parts and other special services;',
      'Provide centralized maintenance services for the on-site device shutdown control valve, including online maintenance and offline repair;',
      'Provide valve repair services shipped to various repair bases or factories;'
    ]
  },
  rights_list: [
    {
      value: 1,
      title: 'You will benefit',
      content: 'Your device can arrange a point-to-point contact for control valve repair, as well as for third-party products'
    },
    {
      value: 2,
      title: 'You will benefit',
      content: 'Years of maintenance experience and deep manufacturer expertise ensure the safety and reliability of recycled valves'
    },
    {
      value: 3,
      title: 'You will benefit',
      content: 'All control valves (including third party control valves) are guaranteed to look and perform perfectly after repair'
    },
    {
      value: 4,
      title: 'You will benefit',
      content: 'All valves have a history document to ensure transparency and can be viewed online at any time'
    }
  ]
}

// 在线维保
const onlineMaintenance = {
  title: 'Foreseeability guards industrial pulsation',
  content: `
  Wuxi Kelke online maintenance service with predictive maintenance as the core, real-time monitoring of valve health status through intelligent diagnosis system, accurate prevention of hidden trouble.<br />
  Based on the Industrial Internet of Things (IIoT) platform and the full life cycle health database, it provides full-brand compatible customized maintenance solutions - from intelligent early warning of sealing components to remote calibration of actuators, adapting to harsh scenarios such as ultra-low temperature and nuclear power, so that non-KELK brand valves also enjoy original factory-grade operation and maintenance standards, synchronously achieving energy efficiency optimization and cost reduction.
  `,
  group1: {
    title: 'The maintenance services we provide mainly include',
    list: [
      'Provide users with the whole plant or part of the control valve 365*24 transportation services',
      'Provide users with regular inspection or spot inspection service of the control valve of the whole plant or part of the device',
      'Provide on-site installation and commissioning of control valves, guiding driving services'
    ]
  },
  group2: {
    title: 'If you need help and advice on valve overhaul and repair, please contact us.',
    content: 'Our customers include industry leading companies such as Agip, Aramco, BP, ConocoPhillips, ExxonMobil, Fina, Petronas, and Petrobras',
    button_text: 'Contact us'
  },
  rights_list_title: 'You will benefit',
  rights_list: [
    'One-stop valve maintenance service, 24 hours on call',
    'Experienced KELK experts and specialized manufacturers ensure the safety and reliability of the equipment',
    'Start your equipment smoothly, secure your equipment, and achieve maximum productivity from the start',
    'Make necessary repairs in a timely manner and replace parts before they wear out to improve operational reliability and avoid downtime',
    'Professional maintenance planning and equipment operation, compliance with the maintenance period, so that the control valve cost optimization'
  ]
}

// 备件测绘
const sparePartsMapping = {
  title: 'Driven by accurate reproduction and agile response',
  content: `
  Wuxi Kelke relies on three-dimensional laser mapping and intelligent reverse engineering system, covering 150# to 2500# valve core components, to achieve 95% of common parts 24 hours fast delivery.<br />
  Through the industrial Internet platform and the global Top10 valve manufacturers spare parts data link collaboration, provide non-standard parts dynamic modeling, special alloy custom melting casting and sealing components bionic optimization services, synchronous implementation of ISO 9001/API 6D standard quality inspection, enabling old equipment refresh and upgrade and full life cycle management.
  `,
  group1: [
    {
      title: 'Customer zero inventory',
      content: `By providing customers with "zero inventory" spare parts service at the nearest service center, the warehouse management system can provide optimal spare parts storage recommendations, thereby preventing overstock or spare parts shortages. Reduce storage costs and improve availability`,
    },
    {
      title: 'Reverse engineering',
      content: `Mapping out the processing of various special valves or non-standard valve internals; In a short time can provide brand valves and other valves related to a variety of valve spare parts;`,
    }
  ],
  flowImg: require('@/assets/images1/customer_service/Service_en.png'),
  rights_list_title: 'You will benefit',
  rights_list: [
    'Replace original parts that are no longer available',
    'Avoid mistakes when ordering relevant small parts so that nothing is missed',
    'Compared with individual orders, it has a price advantage and does not even require a capital occupancy rate',
    'All parts have the same KELK quality assurance as before',
    'Short lead times, improved efficiency, and new operating points can be realized'
  ]
}

// 升级改造
const upgradingAndReconstruction = {
  title: 'Rebuild the vitality of industrial equipment',
  content: `
  With the world's leading valve regeneration technology, Wuxi Kelke enables equipment performance under high temperature, high pressure, strong corrosion and other working conditions to jump, extend service life by 300% and significantly improve energy efficiency.<br />
  Through customized transformation solutions such as multi-stage pressure reduction labyrinth valve core, hard sealed plasma coating, LCV anti-cavitation alloy components, it ADAPTS to scenarios such as supercritical thermal power and LNG cryostorage and transportation, and simultaneously implants intelligent sensors and fluid dynamics simulation optimization systems to meet API 6D stringent certification standards, making traditional valves full of new value in the intelligent industrial era.
  `,
  group1: {
    title: 'How can we help our customers',
    subTitle: 'KELK has always focused on optimizing equipment performance throughout the valve life cycle through retrofit and maintenance.',
    help_txt_list: [
      'Provide technical consultation, special design and manufacture of valves under special conditions in the process of device renovation.',
      'Provide the valve later material upgrade, heat treatment and material surface hardening upgrade, processing and transformation.',
      'Provide later spray or anti-corrosion upgrades of valves.'
    ],
  },
  rights_list1_title: 'You will benefit',
  rights_list1: [
    'More reliable performance, better use and longer life can be achieved through the design of improved and better performance materials or special materials.',
  ],
  rights_list2_title: 'To do this, we follow a specific upgrade process',
  rights_list2: [
    'We can propose upgrades for materials, valve internals, etc., and then create detailed implementation plans based on these initial recommendations. And make sure all upgraded parts come with a 12-month warranty.',
    'We offer ongoing expert consultation, either by phone, email or onsite on request.',
    'For existing KELK valves, we can provide rapid replacement services, and we can also advise third party valve equipment upgrades and valve internals refit.'
  ]
}

// 诊断测试
const diagnosticTest = {
  title: 'Accurately escort the whole life cycle',
  content: `
  Wuxi Kelke is equipped with high-precision detection matrix, X-ray detection, ultrasonic defect location, metallographic microanalysis and other more than 20 non-destructive testing, covering the full dimension assessment of material stress-corrosion-fatigue. Relying on ASTM/EIC standard metallurgical and electronic joint test platform, we provide intelligent sensor life prediction and fluid dynamics simulation verification simultaneously, and customize ASME B16.34 compliance diagnosis reports for hydrogen energy storage and transportation, supercritical thermal power and other scenarios, so as to drive equipment safety improvement with data.
  `,
  grid_menu_title: [
    'Condition monitoring',
    'Performance and efficiency testing',
    'Noise measurement',
    'Vibration and stress analysis',
    'Engineering design',
    'Materials engineering and systems analysis',
    'Upgrade and revaluation of advanced equipment ',
    'Reverse engineering and component reinforcement'
  ],
  rights_list_title: 'You will benefit',
  rights_list: [
    'The valve operation data is efficient and transparent to ensure continuous operation of the valve',
    'Improve economy and availability by identifying optimization potential or damage causes',
    `Manufacturer's know-how - from operating conditions, modification of materials and valve structure to valve redesign`
  ]
}

// 技术培训
const technicalTraining = {
  title: 'Empowering the industrial talent ecosystem',
  content: `
  Based on 60 years of practical experience, Wuxi Kelke has created a whole life cycle management course system for valves in high-end fields such as energy storage and LNG to help customers build a professional engineer team.<br />
  Through the immersive training matrix certified by ASME BPE, which covers 3D disassembly simulation, intelligent diagnosis sandtable drill and standard case library, we provide special training such as hydrogen energy storage and transportation valve operation and maintenance, ultra-low temperature seal failure analysis, etc., with the three-dimensional enabling mode of "theory + factory reality + digital diagnosis", the technology inheritance matches the strategic upgrading needs of enterprises.
  `,
  group1: [
    {
      title: 'Empower industrial intelligent manufacturing talent chain',
      content: `With the core of "full scene combat enabling", we create a stepped training system for enterprises - from basic valve operation and maintenance to precision diagnosis technology, covering ASME BPE certification courses, intelligent positioner joint adjustment and ultra-low temperature failure analysis and other advanced modules. Relying on the three-dimensional fluid simulation platform and intelligent diagnosis sand table, combined with the standard case library, customized growth paths for junior technicians to senior engineers, helping enterprises to achieve a 45% failure rate and 60% maintenance efficiency. Provide periodic certification training for end users such as LNG storage and transportation, hydrogen energy engineering, and collaborate with the world's top laboratories to develop VR immersive disassembly and disassembly simulation systems, build a strong industrial safety defense line with digital knowledge system, and establish a "technical talent pool" and lifelong learning archives for enterprises, enabling the iterative upgrading of the core competitiveness of China Intelligent Manufacturing`
    },
    {
      title: `Reconfigurable fluid control technology <br /><br />`,
      content: `Led by ASME/API certified experts, we aim to create a dual-track teaching model of "ABP + Global joint training" - providing immersive factory reality courses in Wuxi Intelligent Manufacturing Center, Jiangsu Province, or conducting customized training sessions in customer-designated places. The curriculum system is mainly based on "stepped knowledge map" as the core: from basic empowerments such as valve fluid mechanics principle and modular disassembly, to advanced challenges such as supercritical working condition parameter calculation and three-dimensional reverse engineering simulation, and synchronically integrated into practical cases such as life prediction of power station main steam valve and LNG cryogenic seal failure analysis. Relying on the intelligent diagnosis sand table and VR virtual assembly system, to achieve the skills of students, help enterprises to reduce the failure rate of equipment by 50%, reduce the maintenance cost by 35%, and empower the global competitiveness of China's intelligent manufacturing with a closed loop of technology ecology`
    },
  ],
  group2: {
    title: 'Elite talent full link enabling program',
    txt_list: [
      `With the "step enabling model" as the core, based on the practical experience of serving more than 200 energy giants in 30 countries around the world, we tailor-made valve life cycle management courses for enterprises - from basic operation and maintenance to nuclear power precision diagnosis, combined with ASME BPE international standards and intelligent fluid simulation technology, accurately match the strategic needs of enterprises.`,
      'Through the fluid dynamics simulation platform, three-dimensional disassembly sand table and API 6D certification case library, students can deeply master cutting-edge skills such as ultra-low temperature seal failure prediction and intelligent positioner coordination. After training, the equipment failure rate is reduced by 40% on average, and the team response efficiency is increased by 60%, helping enterprises to build a technical moat in the era of Industry 4.0.'
    ],
  },
  group3: {
    title: 'Customizable training modules',
    subTitle: 'You can determine the specific content of the training according to the actual needs of your employees, but the following are some of the more general training modules for reference, which can be studied individually or as part of a complete course.',
    list: [
      'Brief introduction of concept and structure of control valve.',
      'Valve and actuator assembly.',
      'Actuator and positioner calibration and actuator reaction.',
      'Maintenance, overhaul and troubleshooting.',
      'The basic principle of size calculation and selection of control valve.',
      'Control valve size, selection and noise calculation.',
      'Use calculation software to select and size control valves.'
    ]
  }
}


export default {
  title: 'Customer Service',
  subTitle: 'Full life cycle service leader',
  tab_list,
  main_content_text,
  main_content_list,
  baseMmaintenance,
  onlineMaintenance,
  sparePartsMapping,
  upgradingAndReconstruction,
  diagnosticTest,
  technicalTraining,
}


// WEBPACK FOOTER //
// ./src/config/lang/en/customerServicePage.js